import * as React from 'react';
import { resendData } from '../../surveyCollector/screenStreams';
import ConnectionError from '../components/ConnectionError';

export const DisplayConnectionError: React.FunctionComponent = (props) => {
  return <ConnectionError onTrySendClick={resendData} />;
};
